/*
 *   File : bank.js
 *   Author : https://evoqins.com
 *   Description : Bank card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

import Icon from '../Icon/icon';

// Colors
import Colors from "../../Style/Component/card.module.scss";

function PrimaryBank({ data }) {
    return (
        <div className="e-border-1px-lavender-blue e-border-radius-16 padding-12px-all">
            <div className="d-flex align-items-center gap-2 mb-2 pb-1">
                {/* <img
                    src="/Assets/Images/banks/south-indian-bank.png"
                    alt="Bank"
                    width={32}
                    height={32}
                    className='e-border-radius-8'
                /> */}
                <div className="d-flex flex-column gap-1">
                    <p className="e-text-charleston-green e-font-14 e-font-weight-500 e-alt-font-poppins mb-0">
                        {data.bank_name}
                    </p>
                    <span className="e-text-dark-jet e-font-12 e-alt-font-poppins">
                        {data.account_number
                            ? `${"X".repeat(data.account_number.length - 4)}${data.account_number.slice(-4)}`
                            : ""}
                    </span>
                </div>
            </div>
            <div className="d-flex align-items-center gap-6px e-bg-ghost-white-2 p-2 e-border-radius-8">
                <Icon icon="info"
                    size="1rem"
                    color={Colors.dark_jet} />
                <p className="e-text-black e-font-12 e-font-weight-400 e-alt-font-poppins mb-0">
                    To change your primary bank, open Menu &rarr; Manage Bank and add or select a new primary bank.
                </p>
            </div>

        </div>
    )
}

export default PrimaryBank;